import React, { useEffect, useState } from 'react';
import axios from 'axios'; // Import Axios
import { useLocation } from 'react-router-dom'; // Import useLocation to access query parameters
import Header from '../../common/header';
import Footer from '../../common/footer';
import '../Blogs/blogcontent.css'

function BlogContent() {
  const location = useLocation(); // Get the location object
  const query = new URLSearchParams(location.search); // Parse the query parameters
  const postId = query.get('id'); // Get the post ID from the query parameters
  const [post, setPost] = useState(null); // State to hold the post details
  const [error, setError] = useState(null); // State to hold error messages
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const imageStyle = {
    width: '100%',  // Image takes full width of its container
    height: 'auto', // Maintain the aspect ratio
    maxWidth: windowWidth < 768 ? '100%' : '800px', // Adjust maxWidth based on screen size
  };
  useEffect(() => {
    const fetchPostDetails = async () => {
      if (!postId) { // Check if postId is undefined
        setError("Post ID is missing. Please check the URL."); // Set error if postId is not available
        return; // Exit the function early
      }
      try {
        const response = await axios.get(`https://tita.itrain.io/blog/get/${postId}`);
        console.log("API Response:", response.data); // Log the response data
        if (response.data && response.data.success) {
          setPost(response.data.blog); // Update to use 'blogs' instead of 'blog'
        } else {
          setError("Failed to fetch post details. Please try again later.");
        }
      } catch (error) {
        if (error.response) {
          setError("Failed to fetch post details. Please try again later. Error: " + error.response.data.message);
        } else {
          setError("Network error. Please check your connection.");
        }
      }
    };

    fetchPostDetails();
  }, [postId]); // Fetch post details when the component mounts or when the ID changes

  if (error) {
    return <div className="error-message">{error}</div>; // Display error message if there is an error
  }


  return (
    <>
      <Header />
      <div className="post-details">
        {post ? ( // Check if post is available before rendering
          <>
            <h2 className="post-title hover-effect">{post.title}</h2>
            <img
      src={post.image}
      alt="Post"
      className="post-image hover-effect"
      style={imageStyle}
    />
            <div className="post-content">
              {post.desc.split('\n').map((line, index) => {
                const isPoint = line.trim().match(/^\d+\.\s/);
                const isKeyUseCases = line.includes("Key Use Cases:");
                const isSpecialPhrase = [
                  "Why Learn It in 2025:",
                  "Why It's Popular:",
                  "Conclusion",
                ].some(phrase => line.includes(phrase));
                const isBulletPoint = line.trim().startsWith('■');
  
                const shouldBold = isPoint || isKeyUseCases || isSpecialPhrase;
  
                return (
                  <p key={index} className="post-paragraph" style={{ margin: 0, lineHeight: '2', textAlign: 'justify', marginLeft: isBulletPoint ? '20px' : '0' }}>
                    {shouldBold ? <strong>{line}</strong> : line}
                  </p>
                );
              })}
            </div>
          </>
        ) : (
          <p>Loading post...</p> // Display a loading message while fetching data
        )}
      </div>
      <Footer />
    </>
  );
  
}

export default BlogContent;